module.exports = __webpack_public_path__ + "static/media/nissan-thumbs.d5af078c.svg";